import React, { useEffect } from "react";
import { useState } from "react";
import { Link, useParams } from "react-router-dom";
import {
  Box,
  Typography,
  Button,
  Grid,
  Tabs,
  Tab,
  FormControlLabel,
  FormGroup,
  CircularProgress,
} from "@mui/material";
import { CustomCheckBox } from "../../components/CheckboxComp";
import Checkbox from "@mui/material/Checkbox";
import TabPanel from "../../components/TabPanel";
import BillItems from "./bill/items";
import BillRelationship from "./bill/relationship";
import BillCommunication from "./bill/communication";
import BillRelatedRecords from "./bill/relatedRecords";
import BillSystemInformation from "./bill/systemInformation";
import BillCustom from "./bill/custom";
import {
  getTransactionEft,
  getTransactionJPMorganDetails,
  getTransactionSalesOrderTaxAndReporting,
  getTransactionVendorBilling,
} from "../../api/transaction-type";
import BillAvaTax from "./bill/avaTax";
import { getTransactionVendorBillDetail } from "../../api/vendor-bill";
import { useSelector } from "react-redux";
import useSnackbar from "../../hooks/useSnackbar";
import BillEft from "./bill/eft";
import TransferGlImpact from "./bill/gl-impact";
import BillBilling from "./bill/billing";
export default function TransactionTypeBill() {
  const params = useParams();
  const snackbar = useSnackbar();
  const { data: user } = useSelector((state) => state.user);
  /*----------------Tabs-----------------*/
  const [tabIndex, setTabIndex] = useState(0);

  /*----------------End Tabs-----------------*/
  const [rowData, setRowData] = useState([]);
  const [gstHstData, setGstHstData] = useState("");
  const [pstData, setPstData] = useState("");
  const [jpMorganData, setJpMorganData] = useState([]);
  const [eftData, seteftData] = useState([]);
  const [tax_R_Data, setTax_R_Data] = useState([]);
  const [Billing_Data, setBilling_Data] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user.token) {
      getTransactionDocDetailTableData();
    }
  }, []);

  async function getTransactionDocDetailTableData() {
    setLoading(true);
    try {
      const { data } = await getTransactionVendorBillDetail(user.token, {
        tranid: params.docNo,
        limit: 1,
        offset: 0,
        // type: pageDetail.path,
      });
      setRowData(data.data.details);
      setGstHstData(data.data.gst_hst);
      setPstData(data.data.pst);
      return {
        rows: data.data.details,
        total: data.data.Detailstotal,
        error: false,
      };
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
      setLoading(false);
    }
  }

  async function getJPMorganEftData(limit = 10, offset = 0) {
    try {
      const { data } = await getTransactionJPMorganDetails(user.token, {
        tranid: params.docNo,
        limit,
        offset,
      });
      setJpMorganData(data.data.details[0]);
    } catch (error) {
      console.log(error);
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
    }
  }
  async function getTransactionEftData() {
    try {
      const { data } = await getTransactionEft(user.token, {
        id: params.docNo,
      });
      seteftData(data.data.data);
      return { rows: data.data.data, total: data.data.total, error: false };
    } catch (error) {
      console.log(error);
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
    }
  }

  // async function getTransactionbillingData() {
  //   try {
  //     const { data } = await getTransactionVendorBilling(user.token, {
  //       id: params.docNo,
  //     });
  //     setBilling_Data(data.data.data);
  //     return { rows: data.data.data, total: data.data.total, error: false };
  //   } catch (error) {
  //     console.log(error);
  //     snackbar.showError("Error In Loading Data.");
  //     return { error: true };
  //   } finally {
  //   }
  // }
  // async function getTransactionVendorBillTaxAndReportingData() {
  //   try {
  //     const { data } = await getTransactionSalesOrderTaxAndReporting(
  //       user.token,
  //       {
  //         id: params.docNo,
  //       }
  //     );
  //     setTax_R_Data(data.data.data);
  //     return { rows: data.data.data, total: data.data.total, error: false };
  //   } catch (error) {
  //     console.log(error);
  //     snackbar.showError("Error In Loading Data.");
  //     return { error: true };
  //   } finally {
  //   }
  // }

  useEffect(() => {
    if (user.token && tabIndex === 9) {
      getJPMorganEftData();
    }
  }, [user?.token, tabIndex]);

  console.log(jpMorganData, "rows");
  return loading ? (
    <>
      <Typography component="h2" fontWeight={500} className="pageTitle">
        Bill
      </Typography>

      {/*Primary Information*/}
      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
            Primary Information
          </Typography>
          <Link to={"/transaction-type/" + params.slug}>
            <Button size="small" variant="contained" className="backBtn">
              Go Back
            </Button>
          </Link>
        </Box>
        <Box className="viewDetilsBox">
          <Grid container className="mb-2">
            <Grid item xs={12}>
              <p
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CircularProgress></CircularProgress>
              </p>
            </Grid>
          </Grid>
        </Box>
      </Box>
    

      {/*Classification*/}
      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
            Classification
          </Typography>
        </Box>
        <Box className="viewDetilsBox">
          <Grid container className="mb-2">
            <Grid item xs={12}>
              <p
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CircularProgress></CircularProgress>
              </p>
            </Grid>
          </Grid>
        </Box>
      </Box>
      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          
        </Box>
        <Box className="viewDetilsBox">
          <Grid container className="mb-2">
            <Grid item xs={12}>
              <p
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CircularProgress></CircularProgress>
              </p>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </>
  ) : (
    <>
      <Typography component="h2" fontWeight={500} className="pageTitle">
        Bill
      </Typography>

      <Typography component="h4" style={{ marginBottom: "8px" }}>
        <span style={{ marginRight: "16px" }} className="para-no">
          <strong style={{ marginRight: "5px" }}>
            {rowData[0]?.vendor_invoice_number}
          </strong>
          {rowData[0]?.vendor_name}
        </span>
        <Button className="blue-button" size="small">
          {rowData[0]?.status}
        </Button>
      </Typography>
      {/*Primary Information*/}
      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
            Primary Information
          </Typography>
          <Link to={"/transaction-type/" + params.slug}>
            <Button size="small" className="backBtn">
              Go Back
            </Button>
          </Link>
        </Box>
        <Box className="viewDetilsBox">
          {rowData?.map((el, i) => (
            <Grid container className="mb-2" key={i}>
              <Grid item xs={12} sm={12} md={12}>
                <Grid container className="mb-2">
                  <Grid item xs={12} sm={6} md={4} className="m-b-10">
                    <p className="tFormlabel">TRANSACTION NUMBER</p>
                    <p className="tFormName">{el?.transaction_number}</p>
                  </Grid>
                  {/* <Grid item xs={12} sm={6} md={4} className="m-b-10">
                    <FormGroup>
                      <FormControlLabel
                        control={<checkbox  disabled/>}
                        label="PAYMENT HOLD"
                      />
                    </FormGroup>
                  </Grid> */}
                  <Grid item xs={12} sm={6} md={4} className="m-b-10">
                    <p className="tFormlabel">DATE</p>
                    <p className="tFormName">{el?.date}</p>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} className="m-b-10">
                    <p className="tFormlabel">REMITTANCE DESCRIPTION/MEMO</p>
                    <p className="tFormName">{el?.remittance_description}</p>
                  </Grid>

                  <Grid item xs={12} sm={6} md={4} className="m-b-10">
                    <p className="tFormlabel">VENDOR</p>
                    <p className="tFormName">{el?.vendor_name}</p>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} className="m-b-10">
                    <p className="tFormlabel">POSTING PERIOD</p>
                    <p className="tFormName">{el?.posting_period}</p>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} className="m-b-10">
                    <p className="tFormlabel">AP COMMENTS</p>
                    <p className="tFormName">{el?.ap_comments}</p>
                  </Grid>

                  <Grid item xs={12} sm={6} md={4} className="m-b-10">
                    <p className="tFormlabel">VENDOR INVOICE NO.</p>
                    <p className="tFormName">{el?.vendor_invoice_number}</p>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} className="m-b-10">
                    <p className="tFormlabel">DUE DATE</p>
                    <p className="tFormName">{el?.due_date}</p>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} className="m-b-10">
                    <p className="tFormlabel">INVOICE NAME</p>
                    <p className="tFormName">{el?.invoice_name}</p>
                  </Grid>

                  <Grid item xs={12} sm={6} md={4} className="m-b-10"></Grid>
                  <Grid item xs={12} sm={6} md={4} className="m-b-10">
                    <p className="tFormlabel">AMOUNT</p>
                    <p className="tFormName">{el?.amount}</p>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} className="m-b-10">
                    <p className="tFormlabel">SOURCE AP CHECK REQUEST</p>
                    <p className="tFormName">{el?.source_ap_check_req}</p>
                  </Grid>

                  <Grid item xs={12} sm={6} md={4} className="m-b-10">
                    <p className="tFormlabel">PC/PROJECT</p>
                    <p className="tFormName">{el?.pc_project}</p>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} className="m-b-10">
                    <p className="tFormlabel">SPECIAL MAIL INSTRUCTIONS</p>
                    <p className="tFormName">{el?.special_mail_instructions}</p>
                  </Grid>

                  <Grid item xs={12} sm={6} md={4} className="m-b-10">
                    <p className="tFormlabel">A/P ACCOUNT</p>
                    <p className="tFormName">{el?.ap_account}</p>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} className="m-b-10"></Grid>
                  <Grid item xs={12} sm={6} md={4} className="m-b-10">
                    <p className="tFormlabel">CURRENCY</p>
                    <p className="tFormName">{el?.currency}</p>
                  </Grid>
                  {/* <Grid item xs={12} sm={6} md={4} className="m-b-10"></Grid> */}
                  <Grid item xs={12} sm={6} md={4} className="m-b-10">
                    <p className="tFormlabel">NSC PO NUMBER</p>
                    <p className="tFormName">{el?.disc_amt}</p>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} className="m-b-10"></Grid>
                  <Grid item xs={12} sm={6} md={4} className="m-b-10"></Grid>
                  {el?.accrual_related === "false" ||
                  el?.accrual_related === "" ? (
                    <Grid item xs={12} sm={4} md={4} className="m-b-10">
                      <p className="tFormlabel">
                        <FormGroup>
                          <FormControlLabel
                            control={<Checkbox disabled />}
                            label="ACCRUAL RELATED SPECIAL MAIL INSTRUCTIONS"
                          />
                        </FormGroup>
                      </p>
                    </Grid>
                  ) : (
                    <Grid item xs={12} sm={4} md={4} className="m-b-10">
                      <p className="tFormlabel">
                        <FormGroup>
                          <FormControlLabel
                            control={<Checkbox checked disabled />}
                            label="ACCRUAL RELATED SPECIAL MAIL INSTRUCTIONS"
                          />
                        </FormGroup>
                      </p>
                    </Grid>
                  )}
                  {/* <CustomCheckBox
                    title={"ACCRUAL RELATED SPECIAL MAIL INSTRUCTIONS"}
                    data={el?.is_seller_importer_of_period}
                  /> */}
                  <Grid item xs={12} sm={6} md={4} className="m-b-10"></Grid>
                  <Grid item xs={12} sm={6} md={4} className="m-b-10"></Grid>
                  <Grid item xs={12} sm={6} md={4} className="m-b-10">
                    <p className="tFormlabel">ORIGINAL INVOICE DATE</p>
                    <p className="tFormName">{el?.original_invoice_date}</p>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          ))}
        </Box>
      </Box>
      {/*Classification*/}
      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
            Classification
          </Typography>
        </Box>
        <Box className="viewDetilsBox">
          {rowData?.map((el, i) => (
            <Grid container className="mb-2" key={i}>
              <Grid item xs={12} sm={6} md={4} className="m-b-10">
                <p className="tFormlabel">Subsidiary</p>
                <p className="tFormName">{el?.subsidiary}</p>
              </Grid>

              <Grid item xs={12} sm={6} md={4} className="m-b-10">
                <p className="tFormlabel">Department</p>
                <p className="tFormName">{el?.department}</p>
              </Grid>

              <Grid item xs={12} sm={6} md={4} className="m-b-10">
                <p className="tFormlabel">SERVICE LINE</p>
                <p className="tFormName">{el?.service_line}</p>
              </Grid>
            </Grid>
          ))}
        </Box>
      </Box>
      <Box>
        <Box
          className="viewBox "
          sx={{
            maxWidth: { xs: "100%", sm: "100%", md: "100%" },
            bgcolor: "#fff",
          }}
        >
          <Tabs
            value={tabIndex}
            onChange={(e, nv) => {
              setTabIndex(nv);
            }}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="scrollable auto tabs example"
            className="tabs-bkg"
          >
            <Tab label="Expenses and Items" />
            <Tab label="Billing" />
            <Tab label="Relationships" />
            <Tab label="Communication" />
            <Tab label="Related Records" />
            <Tab label="System Information" />
            <Tab label="Custom" />
            <Tab label="EFT" />
            <Tab label="GL Impact" />
            <Tab label="J.P.Morgan" />
            {/* <Tab label="Approval History" /> */}
            {/* <Tab label="Open Air" />
            <Tab label="Philippines Invoicing" /> */}
            <Tab label="AvaTax" />
          </Tabs>
          {/*------------Items------------*/}
          <TabPanel value={tabIndex} index={0}>
            <BillItems />
          </TabPanel>
          {/*------------Billing------------*/}
          <TabPanel value={tabIndex} index={1}>
            {tabIndex === 1 && <BillBilling />}
          </TabPanel>
          {/*------------Relationships------------*/}
          <TabPanel value={tabIndex} index={2}>
            {tabIndex === 2 && <BillRelationship />}
          </TabPanel>
          {/*------------Communication------------*/}
          <TabPanel value={tabIndex} index={3}>
            {tabIndex === 3 && <BillCommunication />}
          </TabPanel>
          {/*------------Related Record------------*/}
          <TabPanel value={tabIndex} index={4}>
            {tabIndex === 4 && <BillRelatedRecords rowData={rowData} />}
          </TabPanel>
          {/*-------------System Information-----------*/}
          <TabPanel value={tabIndex} index={5}>
            {tabIndex === 5 && <BillSystemInformation />}
          </TabPanel>
          {/*-------------CUSTOM-----------*/}
          <TabPanel value={tabIndex} index={6}>
            {tabIndex === 6 && <BillCustom />}
          </TabPanel>
          {/*------------EFT-----------*/}
          <TabPanel value={tabIndex} index={7}>
            {tabIndex === 7 && <BillEft tabIndexP={tabIndex} />}
          </TabPanel>
          {/*------------gl impact------------*/}
          <TabPanel value={tabIndex} index={8}>
            {tabIndex === 8 && <TransferGlImpact />}
          </TabPanel>
          {/*-------------jp Morgan-----------*/}
          <TabPanel value={tabIndex} index={9}>
            <Box className="viewDetilsBox">
              {/* {tax_R_Data?.map((el, index) => (
              <Box className="viewDetilsBox" key={index}> */}
              <Grid container>
                <Grid item xs={12} sm={6}>
                  <p className="tFormlabel">J.P.MORGAN REFERENCE ID</p>
                  <p className="tFormName">{jpMorganData?.reference_id}</p>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <p className="tFormlabel">J.P.MORGAN STATUS</p>
                  <p className="tFormName">{jpMorganData?.status}</p>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <p className="tFormlabel">J.P.MORGAN MESSAGE</p>
                  <p className="tFormName">{jpMorganData?.message}</p>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <p className="tFormlabel">J.P.MORGAN UPDATED DATE</p>
                  <p className="tFormName">{jpMorganData?.updated_date}</p>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <p className="tFormlabel">J.P.MORGAN PAYER</p>
                  <p className="tFormName">{jpMorganData?.payer}</p>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <p className="tFormlabel">J.P.MORGAN TRANSACTION ID</p>
                  <p className="tFormName">{jpMorganData?.transaction_id}</p>
                </Grid>
              </Grid>
            </Box>
            {/* ))} */}
          </TabPanel>
          {/*------------Approval History------------*/}
          {/* <TabPanel value={tabIndex} index={9}>
            {tabIndex === 9 && <TransferGlImpact />}
          </TabPanel> */}
          {/*------------Philippines Invoicing-----------*/}
          {/* <TabPanel value={tabIndex} index={11}>
            <PhilippinesInvoicing />
          </TabPanel> */}
          {/*------------AvaTax-----------*/}
          <TabPanel value={tabIndex} index={10}>
            {tabIndex === 10 && <BillAvaTax />}
          </TabPanel>
        </Box>
      </Box>
    </>
  );
}
